/* HOUSE of KAZI - lightweight interactions: hover mega menu and accordion drawer only. No scroll listeners. */
(function () {
  if (window.__kazi) return;
  window.__kazi = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var hoverNav = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  function setOpen(d, open) {
    var s = d.querySelector('summary');
    if (open) d.setAttribute('open', '');
    else d.removeAttribute('open');
    if (s) s.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* ---------- Desktop mega menu: opens on hover ---------- */
  function initMega() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.header__inline-menu header-menu'));
    if (!items.length) return;
    var timer;

    function closeAll(except) {
      items.forEach(function (m) {
        var d = m.querySelector('details');
        if (d !== except && d.hasAttribute('open')) setOpen(d, false);
      });
    }

    items.forEach(function (m) {
      if (m.dataset.kz) return;
      m.dataset.kz = '1';
      var d = m.querySelector('details');
      m.addEventListener('mouseenter', function () {
        if (!hoverNav.matches) return;
        clearTimeout(timer);
        closeAll(d);
        setOpen(d, true);
      });
      m.addEventListener('mouseleave', function () {
        if (!hoverNav.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () { setOpen(d, false); }, 200);
      });
      d.querySelector('summary').addEventListener('click', function (e) {
        if (!hoverNav.matches) return;
        e.preventDefault();
        if (e.detail === 0) setOpen(d, !d.hasAttribute('open'));
      });
    });

    document.querySelectorAll('.header__inline-menu > ul > li').forEach(function (li) {
      if (li.querySelector('header-menu')) return;
      li.addEventListener('mouseenter', function () { if (hoverNav.matches) closeAll(); });
    });

    if (!document.documentElement.dataset.kzEsc) {
      document.documentElement.dataset.kzEsc = '1';
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    }
  }

  /* ---------- Mobile drawer: inline accordion ---------- */
  function collapse(d) {
    var panel = d.querySelector(':scope > .menu-drawer__submenu');
    var sum = d.querySelector(':scope > summary');
    if (sum) sum.setAttribute('aria-expanded', 'false');
    if (!panel || reduce.matches) { d.removeAttribute('open'); return; }
    var h = panel.offsetHeight;
    panel.style.overflow = 'hidden';
    var a = panel.animate([{ height: h + 'px' }, { height: '0px' }], { duration: 180, easing: 'ease' });
    a.onfinish = function () { d.removeAttribute('open'); panel.style.overflow = ''; };
  }

  function toggleItem(d) {
    var panel = d.querySelector(':scope > .menu-drawer__submenu');
    var sum = d.querySelector(':scope > summary');
    if (!panel) return;
    if (d.hasAttribute('open')) { collapse(d); return; }
    var list = d.closest('ul');
    if (list) {
      list.querySelectorAll(':scope > li > details[open]').forEach(function (o) { if (o !== d) collapse(o); });
    }
    d.setAttribute('open', '');
    if (sum) sum.setAttribute('aria-expanded', 'true');
    if (reduce.matches) return;
    var h = panel.scrollHeight;
    panel.style.overflow = 'hidden';
    var a = panel.animate([{ height: '0px' }, { height: h + 'px' }], { duration: 220, easing: 'ease' });
    a.onfinish = function () { panel.style.overflow = ''; };
  }

  function initDrawer() {
    document.querySelectorAll('header-drawer').forEach(function (drawer) {
      if (drawer.dataset.kz) return;
      drawer.dataset.kz = '1';
      var main = drawer.querySelector('details');
      var nav = drawer.querySelector('.menu-drawer__navigation');
      if (!main) return;

      if (nav && !nav.querySelector('.kz-drawer-close')) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'kz-drawer-close';
        b.setAttribute('aria-label', 'Close menu');
        b.innerHTML = `<span>Close</span><svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' aria-hidden='true'><path d='M5 5l14 14M19 5L5 19'/></svg>`;
        b.addEventListener('click', function () {
          var s = main.querySelector('summary');
          if (s) s.click();
        });
        nav.insertBefore(b, nav.firstChild);
      }

      drawer.addEventListener('click', function (e) {
        var sum = e.target.closest('summary.menu-drawer__menu-item');
        if (!sum || !drawer.contains(sum)) return;
        e.preventDefault();
        e.stopPropagation();
        toggleItem(sum.parentElement);
      }, true);

      main.addEventListener('toggle', function () {
        if (main.open) return;
        drawer.querySelectorAll('.menu-drawer__menu details[open]').forEach(function (d) {
          d.removeAttribute('open');
          var s = d.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        });
      });
    });
  }

  function init() {
    initMega();
    initDrawer();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
